import styled from 'styled-components'
import { styles } from '../../../../styles/themes/style'

export const PLAN_CARDS_SIDE_BY_SIDE = 960

/** Plan cards and the Enterprise block share these widths so their edges line up. */
export const pricingContentWidth = `
    width: 100%;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;

    @media only screen and (min-width: ${PLAN_CARDS_SIDE_BY_SIDE}px) {
        max-width: 980px;
    }
`

// Shared shell of the Growth and Done-for-you cards (header, feature list, footer).
// Side by side, each card takes the parent's three rows as a subgrid, so headers, lists and CTAs
// line up across both cards and the cards share one height whatever text wraps.
// No transform on hover: a composited layer drops ClearType on Windows and small text looks off.
export const PlanCard = styled.div<{ $highlighted?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 32px 20px 20px 20px;
    border-radius: 16px;
    background-color: ${styles.colors.white};
    border: 2px solid ${({ $highlighted }) => $highlighted ? styles.colors.primary600 : styles.colors.black200};
    box-shadow: ${({ $highlighted }) => $highlighted ? '0 0 8.35px rgba(89, 100, 255, 0.5)' : 'none'};
    transition: box-shadow .3s ease;

    &:hover {
        box-shadow: ${({ $highlighted }) => $highlighted
            ? '0 0 8.35px rgba(89, 100, 255, 0.5), 0 16px 36px -14px rgba(88, 100, 255, 0.32)'
            : '0 16px 36px -16px rgba(26, 31, 43, 0.22)'};
    }

    @media only screen and (min-width: ${PLAN_CARDS_SIDE_BY_SIDE}px) {
        display: grid;
        grid-row: span 3;
        grid-template-rows: subgrid;
        row-gap: 22px;
    }

    @media only screen and (max-width: 599px) {
        padding: 28px 16px 16px 16px;
    }
`
export const PlanCardHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`
export const PlanTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`
export const PlanTitleRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`
export const PlanTitle = styled.h3`
    margin: 0;
    font-family: NunitoSans;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: ${styles.colors.black600};
`
export const PlanDescription = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${styles.colors.black400};
`
/** Big price line, shared so "$69.30" and "Custom service" sit on the same baseline */
export const PlanPriceText = styled.span`
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -1.2px;
    color: ${styles.colors.black600};

    @media only screen and (max-width: 599px) {
        font-size: 40px;
        line-height: 44px;
    }
`
export const PlanFooter = styled.div`
    padding-top: 12px;
`
const CtaButton = styled.button`
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 8px;
    padding: 0 16px;
    font-family: NunitoSans;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;
    transition: background-color .2s ease;

    &:focus-visible {
        outline: 2px solid ${styles.colors.primary600};
        outline-offset: 2px;
    }
`
export const PrimaryCta = styled(CtaButton)`
    border: none;
    background-color: ${styles.colors.primary600};
    color: ${styles.colors.white};

    &:hover:not(:disabled) { background-color: ${styles.colors.primary500}; }

    &:disabled {
        background-color: ${styles.colors.black100};
        color: ${styles.colors.black300};
        cursor: default;
    }
`
export const OutlineCta = styled(CtaButton)`
    border: 2px solid ${styles.colors.primary600};
    background-color: ${styles.colors.white};
    color: ${styles.colors.primary600};

    &:hover { background-color: #F5F6FF; }
`
// Reserves the same line under both CTAs so they stay aligned
export const PlanFooterNote = styled.p`
    margin: 6px 0 0 0;
    min-height: 16px;
    font-family: NunitoSans;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: ${styles.colors.black400};
`
